import React from 'react';

export const TH = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5971)'>
				<mask
					id='mask0_11534_5971'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5971)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 10H20V15H0V10Z'
						fill='#F50101'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20V3.75H0V0Z'
						fill='#F50101'
					/>
					<path
						d='M0 4.0625H-0.9375V5V10V10.9375H0H20H20.9375V10V5V4.0625H20H0Z'
						fill='#3D58DB'
						stroke='white'
						strokeWidth='1.875'
					/>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5971'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
